import React from 'react';
import PropTypes from 'prop-types';

const Country = ({countries, value, onChange = () => {}, isError = false}) => (
    <div id="row_country" className={`country__item form-group-select-country ${isError ? `form-error` : ``}`}>
        <div className="personal-info__lbl">Country code:*</div>
        <div className="personal-info__value">
            <div className="info__inputWrapper">
                <select value={value}
                        onChange={(event) => {onChange(event.target.value)}}
                        id="country"
                        name="country"
                        className="country-resumes">
                    <option value="">select country code</option>
                    {Object.keys(countries).map(countryId => (
                        <option key={countryId} value={countryId}>{countries[countryId]}</option>
                    ))}
                </select>
            </div>
            {isError &&
                <div className="validation_error err-popup"
                     id="error_country">Select a country code
                </div>
            }
        </div>
    </div>
)

Country.propTypes = {
    countries: PropTypes.objectOf(PropTypes.string).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    isError: PropTypes.bool,
};

export default Country
